export default __webpack_public_path__ + "static/teamspective-logo-regular-color-4b46b893e05243b4ba26d3cc2ca38cf4.svg";